export { StandardSwitch } from './StandardSwitch';
